import { createEmitter } from './emitter';

const expiryEmitter = createEmitter();

// Disabled while a deliberate logout is in flight, so 401s from requests that
// were already in transit when the session was invalidated (e.g. background
// polling) aren't mistaken for an unexpected session expiry. Re-enabled once
// a new session is established.
let sessionExpiryEnabled = true;

export const subscribeToSessionExpiry = expiryEmitter.subscribe;

export function setSessionExpiryEnabled(enabled: boolean): void {
  sessionExpiryEnabled = enabled;
}

export function notifySessionExpired(): void {
  if (!sessionExpiryEnabled) return;
  expiryEmitter.notify();
}
